'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (text, options) {
  return !(0, _isInvalidTweet2.default)(text, options);
};

var _isInvalidTweet = require('./isInvalidTweet');

var _isInvalidTweet2 = _interopRequireDefault(_isInvalidTweet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];